/**
 * Lembrete de gravação esquecida (07/10: a gravação de uma consulta inicial ficou ligada 1h40 depois do fim da
 * conversa, e a nota da visita só saiu quando alguém avisou). Passados 90 min, a faixa do gravador pergunta se a
 * consulta continua; "Continuar gravando" adia a pergunta por 30 min. Só pergunta: nunca para sozinha.
 */
export const LEMBRAR_APOS_MIN = 90;
export const LEMBRAR_DE_NOVO_MIN = 30;

/** "Continuar gravando" vale só para a gravação em que foi clicado (chave = paciente + início). */
export type Adiado = { chave: string; ate: number } | null;

export function deveLembrar(inicio: number, agora: number, chave: string, adiado: Adiado): boolean {
  if (agora - inicio < LEMBRAR_APOS_MIN * 60_000) return false;
  return !(adiado && adiado.chave === chave && agora < adiado.ate);
}

export function adiar(chave: string, agora: number): Adiado {
  return { chave, ate: agora + LEMBRAR_DE_NOVO_MIN * 60_000 };
}
